import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import QuickActionSection from './components/QuickActionSection';
import FirmProfileSection from './components/FirmProfileSection';
import CareersPage from './components/CareersPage';
import ServicesOverviewPage from './components/ServicesOverviewPage';
import PublicationsPage from './components/PublicationsPage';
import TeamPage from './components/TeamPage';
import CashflowPage from './components/CashflowPage';
import VehicleDiaryPage from './components/VehicleDiaryPage';
import PayrollPage from './components/PayrollPage';
import InsurancesPage from './components/InsurancesPage';
import PoliciesPage from './components/PoliciesPage';
import AccessControlPage from './components/AccessControlPage';
import FirmDocumentsPage from './components/FirmDocumentsPage';
import AdminLoginPage from './components/AdminLoginPage';
import AdminEmployeesPage from './components/AdminEmployeesPage';
import { AuthProvider } from './context/AuthContext';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import SpecializationsSection from './components/SpecializationsSection';
import WhyChooseSection from './components/WhyChooseSection';
import TestimonialsSection from './components/TestimonialsSection';
import GallerySection from './components/GallerySection';
import NewsSection from './components/NewsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FloatingContactForm from './components/FloatingContactForm';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Layout component with Header and Footer
function Layout({ children }) {
  return (
    <div className="App">
      <Header />
      {children}
      <Footer />
      <FloatingContactForm />
      <Toaster position="top-right" />
    </div>
  );
}

// Home page component
function HomePage() {
  return (
    <>
      <HeroSection />
      <QuickActionSection />
      <AboutSection />
      <ServicesSection />
      <SpecializationsSection />
      <WhyChooseSection />
      <GallerySection />
      <TestimonialsSection />
      <NewsSection />
      <CTASection />
    </>
  );
}

// Firm Profile page component
function FirmProfilePage() {
  return <FirmProfileSection />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/firm-profile" element={<Layout><FirmProfilePage /></Layout>} />
          <Route path="/careers" element={<Layout><CareersPage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesOverviewPage /></Layout>} />
          <Route path="/publications" element={<Layout><PublicationsPage /></Layout>} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/admin/cashflow" element={<CashflowPage />} />
          <Route path="/admin/vehicles" element={<VehicleDiaryPage />} />
          <Route path="/admin/payroll" element={<PayrollPage />} />
          <Route path="/admin/insurances" element={<InsurancesPage />} />
          <Route path="/admin/policies" element={<PoliciesPage />} />
          <Route path="/admin/access" element={<AccessControlPage />} />
          <Route path="/admin/firm-documents" element={<FirmDocumentsPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/employees" element={<Navigate to="/team" replace />} />
          <Route path="/admin/employees-list" element={<AdminEmployeesPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
